import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { DayCustomersStatistics } from '@api/shipping-data/types/DayCustomersStatistics';
import { WebOrderStatistics } from '@api/shipping-data/types/WebOrderStatistics';
import { getDateWithoutTime } from 'components/global/utils';



export const selectOrders = (state: RootState) => state.orders.orders;
export const selectOrdersPagingInfo = (state: RootState) => state.orders.ordersPagingInfo;
export const selectOrdersFilter = (state: RootState) => state.orders.ordersFilter;
export const selectSelectedOrderUnvId = (state: RootState) => state.orders.selectedOrderUnvId;

export const selectCustomers = (state: RootState) => state.orders.customers;
export const selectCustomersPagingInfo = (state: RootState) => state.orders.customersPagingInfo;
export const selectSelectedCustomerUnvId = (state: RootState) => state.orders.selectedCustomerUnvId;

export const selectSearchSingleOrderUnvId = (state: RootState) => state.orders.searchSingleOrderUnvId;
export const selectGobackReportingsUrl = (state: RootState) => state.orders.gobackReportingsUrl;




export const selectSelectedItemCustomerInfo = createSelector(
	[
		selectOrders,
		selectCustomers,
		selectSelectedOrderUnvId,
		selectSelectedCustomerUnvId,
	],(
		orders: WebOrderStatistics[] | null,
		customers: DayCustomersStatistics[] | null,
		selectedOrderUnvId: string | null,
		selectedCustomerUnvId: string | null,
	) => {
		if (orders && selectedOrderUnvId) {
			let selectedOrder = orders.find(x => x.orderStatistics && x.orderStatistics.unversionedSystemId === selectedOrderUnvId);
			if (!selectedOrder || !selectedOrder.destination || !selectedOrder.orderStatistics) return null;

			return {
				destinationUnvId: selectedOrder.destination.unversionedSystemId,
				destinationId: selectedOrder.destination.systemId,
				customerName: selectedOrder.destination.companyName,
				selectedOrderUnvId: selectedOrderUnvId,
				orderUnvId: selectedOrder.orderStatistics.orderUnversionedSystemId,
				selectedOrderDateWithoutTime: getDateWithoutTime(selectedOrder.orderStatistics.orderRequiredDeliveryDate),
			};
		}

		if (customers && selectedCustomerUnvId) {
			let selectedCustomer = customers.find(x => x.orderUnvDestinationId && x.orderUnvDestinationId === selectedCustomerUnvId);
			if (!selectedCustomer || !selectedCustomer.orderDestination) return null;

			return {
				destinationUnvId: selectedCustomer.orderDestination.unversionedSystemId,
				destinationId: selectedCustomer.orderDestination.systemId,
				customerName: selectedCustomer.orderDestination.companyName,
				selectedOrderUnvId: null,
				orderUnvId: null,
				selectedOrderDateWithoutTime: null,
			};
		}

		return null;
	}
);